import '@/utils/legacyCookieCleanup' // 必须排在最前：要早于 store 读取 token

import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import {formatDate,} from '@/utils/date';
import '@/icons' // icon
import '@/permission' // permission control
Vue.use(ElementUI, { locale })
// v-charts 不再在这里全局注册。
//
// 它是空转的：五个画图的页面——首页和增长分析的四页——每一页都自己
// import 'v-charts/lib/line.common' / 'histogram.common' 并在页面内注册
// （还各自套了 vChartsCompat 那层 Vue 2.7 补丁），全项目没有一处用到
// 全局注册的 <ve-*>。
//
// 而它写在入口里，import 一个 v-charts 就把整个 echarts 连同 bmap/amap/
// liquidfill/wordcloud 扩展一起拽进 chunk-vendors —— 于是登录页、货架前
// 用手机开的 /m/ocr 也要下这一大坨。删掉之后 chunk-vendors 少了九百多 KB
// （生产构建的 parsed size，2026-08 量的，随依赖变动会漂）。
//
// install 本身只是循环 Vue.component 注册 20 个 <ve-*>，没有全局 mixin、
// 没有 Vue.prototype、没有主题或默认配置，所以删掉不会让那五页缺东西。

Vue.config.productionTip = false

// 富文本（Quill）不在这里全局注册了。入口引到的东西一律进 chunk-vendors，
// 于是登录页、货架前用手机开的 /m/ocr 也要下那 212 KB，而全站只有
// 「信息管理」一个页面用得到它。组件和样式都挪到那一页自己去引。


Vue.filter("formatTime", (time) => {
  if (time == null || time === '') {
    return 'N/A';
  }
  let date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
})
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
